export const crossSellStatus = {
  DECLINED: 'DECLINED',
  CANCELLED: 'CANCELLED',
};

export const crossSellAppType = {
  HELOC: 'HELOC',
};
